import verticalSeparator from './verticalSeparator'

export default (member: TMember): string =>
    `Born in ${member.origin.city ? `${member.origin.city} ${verticalSeparator} ` : ''}${member.origin.country.name}`
